import { useMemo } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import type { AssignmentRow } from "./assigned-thalis-utils";
import { buildAssignedThaliTypeBreakdown } from "./assigned-thalis-utils";

type Props = {
  assignments: AssignmentRow[];
};

export default function AssignedThaliTypeBreakdown({ assignments }: Props) {
  const assignedByThaliType = useMemo(
    () => buildAssignedThaliTypeBreakdown(assignments),
    [assignments]
  );

  if (assignments.length === 0) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
        Assigned by thali type
      </Typography>
      <TableContainer
        sx={{
          border: 1,
          borderColor: "divider",
          borderRadius: 1,
          maxWidth: { xs: "100%", sm: 440 },
        }}
      >
        <Table size="small" sx={{ minWidth: 280 }}>
          <TableHead>
            <TableRow>
              <TableCell>Thali type</TableCell>
              <TableCell align="right">Count</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {assignedByThaliType.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.name}</TableCell>
                <TableCell align="right">{row.count.toLocaleString()}</TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell sx={{ fontWeight: "medium" }}>Total</TableCell>
              <TableCell align="right" sx={{ fontWeight: "medium" }}>
                {assignments.length.toLocaleString()}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
